import {
  getLeftMenuList,
  getExplainInfo,
  getMetricInfo,
  addViewDashboard,
} from '@/pages/benchmark/services/benchmark';
import { merge } from 'lodash-es';
import { TBenchmarkModelState, TBenchmarkModel, IMetrics, IMetricsInfo } from './_type';
import { KEY_TYPE_MAP } from '../_config/constant';
import { handleMenuList } from '@/pages/benchmark/utils/utils';
export const namespace = 'benchmark';

const BenchmarkModel: TBenchmarkModel = {
  namespace,
  state: {
    menuList: null, // null 代表未发起请求
    // 浮窗指标
    explainInfo: {},
    allExplainInfo: {}, // 所有指标,
    // 后端指标配置信息
    metricInfo: {},
    allMetricInfo: {}, // 所有指标,
    // 聚合指标配置
    metricConfig: {},
  },

  effects: {
    *query({ }, { }) { },
    // 获取左侧菜单
    *getLeftMenuList({ }, { put }) {
      try {
        // @ts-ignore
        const result: any = yield getLeftMenuList();
        const menuList = handleMenuList(result?.menu_list) || [];
        yield put({
          type: "save", payload: {
            menuList,
          }
        });
      } catch (error) {
        yield put({
          type: "save", payload: {
            menuList: [],
          }
        });
      }
    },
    // 获取页面指标中英文名称和指标中英文注释等信息
    *getExplainInfo({ }, { put }) {
      try {
        const result: {
          [key: string]: IMetrics[];
        } = yield getExplainInfo();
        const explainMap: IMetricsInfo = {};
        Object.keys(result)?.forEach((item) => {
          const key = KEY_TYPE_MAP?.[item] || item;
          const metricItem = result?.[item] || [];
          const obj: any = {};
          if (metricItem && metricItem?.length > 0) {
            metricItem?.forEach((v) => {
              try {
                const value = JSON.parse(v?.value) || {};
                obj[v?.key] = value;
              } catch (error) {
                console.log(error);
              }
            });
          }
          explainMap[key] = obj;
        });
        yield put({
          type: "save", payload: {
            allExplainInfo: explainMap,
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 获取指标配置信息
    *getMetricInfo({ }, { put }) {
      try {
        const result: IMetrics[] = yield getMetricInfo();
        const metricMap: IMetricsInfo = {};
        result?.forEach((item) => {
          const { metric, metric_en: nameEn, metric_cn: nameCn, platform } = item || {};
          const key = KEY_TYPE_MAP?.[platform?.toLowerCase()] || platform?.toLowerCase();
          if (!metricMap?.[key]) {
            metricMap[key] = {};
            const metricObj = { ...item, nameEn, nameCn };
            metricMap[key][metric] = metricObj;
          } else {
            const metricObj = { ...item, nameEn, nameCn };
            metricMap[key][metric] = metricObj;
          }
        });
        yield put({
          type: "save", payload: {
            allMetricInfo: metricMap,
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 用户点击了 New 标记的菜单项，上报已读并取消 NEW 标签
    *cancelMenuNewStatus({ payload }, { put, select }) {
      try {
        const { uId } = payload;
        // 上报已读
        if (uId) {
          yield addViewDashboard({ u_id: uId });
        }
        // 前端立即取消 NEW 标签
        const { menuList } = yield select((state: any) => state[namespace]);
        const removeShowNew = (list: any[]): any[] => {
          return list?.map((item: any) => {
            if (item?.id === uId || item?.u_id === uId) {
              return { ...item, showNew: false, subMenus: removeShowNew(item?.subMenus || []) };
            }
            const updatedSubMenus = removeShowNew(item?.subMenus || []);
            const hasNewChild = updatedSubMenus?.some((sub: any) => sub?.showNew);
            // 重新计算 showNew：自身 new_flag 仍有效（且非目标节点）或子节点有 new
            return { ...item, showNew: (!!item?.new_flag && item?.id !== uId && item?.u_id !== uId) || hasNewChild, subMenus: updatedSubMenus };
          }) || [];
        };
        const updatedMenuList = removeShowNew(menuList || []);
        yield put({ type: 'save', payload: { menuList: [...updatedMenuList] } });
      } catch (e) {
        console.log('取消菜单New标识的上报接口错误:', e);
      }
    },
  },
  reducers: {
    save(state: TBenchmarkModelState, action: any) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setMetricConfig(state, action) {
      const { frameType } = action.payload;
      // pageConfig>七彩石>metricsConfig
      const explainInfo = state?.allExplainInfo?.[frameType] || {};
      const metricInfo = state?.allMetricInfo?.[frameType] || {};
      const metricConfig = merge(metricInfo, explainInfo);
      // console.log(metricConfig, '指标配置');
      return {
        ...state,
        explainInfo,
        metricInfo,
        metricConfig,
      };
    },
  }
};

export default BenchmarkModel;
